/**
 * Bookit.Data.ServiceGroupRegistrationStatus
 */
export enum ServiceGroupRegistrationStatus {
  Approved = 0,
  Rejected = 1,
  Pending = 2,
}
